import React, { useEffect } from 'react'
import { ReportsState, Report, ReportCategory } from '../store/store'
import './Reports.css'
import slugify from 'react-slugify'
import { useHistory } from 'react-router-dom'
import { RequestState } from '../../types'
import Loading from '../../../components/Loading'
import { useTranslation } from 'react-i18next'

type Props = {
  partnerId?: string
  state: ReportsState
  loadReports: () => Promise<void>
}

function Reports(props: Props) {
  const { state, partnerId, loadReports } = props
  const history = useHistory()
  const { t } = useTranslation(['reports'])

  useEffect(() => {
    if (partnerId) {
      loadReports()
    }
  },
    // eslint-disable-next-line
    [partnerId])

  if (state.reports.requestState === RequestState.Loading) {
    return (
     <Loading/>
    )
  } else if (state.reports.requestState === RequestState.Error) {
    return (
      <div className="panel-loading" id="error">
        {t('unable_to_load_reports') }
      </div>
    )
  } else {
    return (
      <div id="reports-content" className="padding-m">
        {state.reports.reports.map((reportCategory: ReportCategory) => (
          <div className="reports-container" key={reportCategory.id}>
            <div>
              <div className="report-category-name">
                <strong>{reportCategory.name}</strong>
              </div>
              <div>
                {reportCategory.description}
              </div>
            </div>
            <div className="reports">
              {reportCategory.reports.map((report: Report) => (
                <div id={slugify(report.name)} key={report.id}
                  className="reports-item">
                  <div className="reports-item-inner" onClick={() => history.push(`/partner/${partnerId}/reports/${report.id}`)}>
                    <div>
                      <div>
                        <strong>{report.name}</strong>
                      </div>
                      <div>
                        <span>{report.description}</span>
                      </div>
                    </div>
                    <div className="flex-center">
                      <i className="fas fa-chevron-right"></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    )
  }
}

export default Reports
